class MenuController {
  /* @ngInject */
  constructor($rootScope, $transitions) {
    let vm = this;

    vm.$onInit = () => {
      // $rootScope.pageTitle = '';
      // $rootScope.pageDescription = '';

      $transitions.onStart({}, () => {
        vm.showMenu = false;
      });
    };
  }
}

export default MenuController;
